import styled from 'styled-components';

export const Root = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 24px;
  padding: 0 12px;
  color: #9095a4;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  border: 1px solid #dbdfea;
  border-radius: 12px;

  &:hover {
    border: 1px solid #9095a4;
  }

  &:active {
    color: #fff;
    background-color: #e1000f;
    border: 1px solid #e1000f;
  }

  &:disabled {
    color: #dbdfea;
  }
`;
